// Shorts vidéo — leçons et campagnes en moins de 60 secondes
// type: 'video' (fichier mp4 vertical) | 'youtube' (embed officiel)
// Les shorts animés (schémas) ont été retirés à la demande de l'utilisateur (22/06/2026).
export const SHORTS = [
  {
    id: 'giratoire-quiz-video',
    type: 'video',
    src: '/assets/videos/short-quiz-giratoire.mp4',
    theme: 'Giratoire',
    kind: 'Quiz vidéo · avec son',
    title: 'Quiz giratoire : teste-toi !',
    course_to: '/cours/analyse-giratoire',
    color: '#dc2626',
    steps: ['Avant, pendant, après le giratoire : réponds aux questions avant la correction. Active le son !'],
    quiz: {
      q: 'Dans le giratoire, ton clignotant DROIT s\'active…',
      options: ['Dès l\'entrée dans l\'anneau', 'Au niveau de la sortie qui précède la mienne', 'Une fois sorti du giratoire'],
      answer: 1,
      explain: 'Le clignotant droit s\'active dès que tu passes la sortie qui précède la tienne : ceux qui attendent peuvent s\'insérer.',
    },
  },
  // ── Shorts officiels Sécurité Routière (YouTube) ──
  {
    id: 'yt-sr-regles-or',
    type: 'youtube',
    ytId: 'wIaytOQg1QY',
    theme: 'Sécurité routière',
    kind: 'Officiel · Sécurité routière',
    title: 'Les règles d\'or pour sortir de chez soi en voiture',
    course_to: '/magazine',
    cta_label: 'Plus d\'actus sécurité routière',
    color: '#1d4ed8',
    steps: ['Campagne officielle Sécurité Routière : les bons réflexes avant chaque départ en voiture.'],
    quiz: {
      q: 'Avant de démarrer, la règle d\'or c\'est…',
      options: ['Partir vite pour éviter le trafic', 'Tout régler à l\'arrêt : siège, rétros, GPS, téléphone rangé', 'Régler le GPS en roulant au pas'],
      answer: 1,
      explain: 'Tous les réglages se font à l\'arrêt, avant de démarrer. Le téléphone au volant, c\'est 135 € et 3 points.',
    },
  },
  {
    id: 'yt-sr-conduite-accompagnee',
    type: 'youtube',
    ytId: 'Pb4cVYxDsko',
    theme: 'Sécurité routière',
    kind: 'Officiel · Sécurité routière',
    title: 'Conduite accompagnée : 15 ans, c\'est le bon moment',
    course_to: '/formation/parcours',
    cta_label: 'Découvrir le parcours AAC',
    color: '#1d4ed8',
    steps: ['L\'AAC dès 15 ans : plus d\'expérience avant l\'examen, un meilleur taux de réussite et une assurance moins chère.'],
    quiz: {
      q: 'La conduite accompagnée (AAC) est possible dès…',
      options: ['14 ans', '15 ans', '17 ans'],
      answer: 1,
      explain: 'L\'AAC démarre dès 15 ans : au moins 3 000 km avec un accompagnateur, un meilleur taux de réussite et une période probatoire réduite.',
    },
  },
  {
    id: 'yt-sr-proto',
    type: 'youtube',
    ytId: 'l-5QHTM5AoU',
    theme: 'Sécurité routière',
    kind: 'Officiel · Sécurité routière',
    title: 'Scooter débridé (proto) : quelles conséquences ?',
    course_to: '/magazine',
    cta_label: 'Plus d\'actus sécurité routière',
    color: '#1d4ed8',
    steps: ['Débrider son deux-roues : amende, confiscation, assurance qui ne couvre plus rien en cas d\'accident.'],
    quiz: {
      q: 'Rouler avec un scooter débridé (« proto »), c\'est…',
      options: ['Toléré si on reste prudent', 'Interdit : amende, confiscation possible, assurance non couverte', 'Légal hors agglomération'],
      answer: 1,
      explain: 'Un deux-roues débridé n\'est plus conforme : amende, confiscation possible, et en cas d\'accident l\'assurance peut refuser toute indemnisation.',
    },
  },
  {
    id: 'yt-sr-respect',
    type: 'youtube',
    ytId: 'hR69nOlr9dU',
    theme: 'Sécurité routière',
    kind: 'Officiel · Sécurité routière',
    title: 'Ornella Ongaro : priorité au respect',
    course_to: '/magazine',
    cta_label: 'Plus d\'actus sécurité routière',
    color: '#1d4ed8',
    steps: ['La pilote Ornella Ongaro rappelle la règle n°1 entre tous les usagers : le respect mutuel sur la route.'],
    quiz: {
      q: 'Entre usagers (voitures, motos, vélos, piétons), la priorité n°1 c\'est…',
      options: ['Le plus rapide passe devant', 'Le respect mutuel et le partage de la route', 'Le plus gros véhicule a toujours raison'],
      answer: 1,
      explain: 'La route se partage : contrôles visuels, distances de sécurité et respect mutuel protègent tout le monde, surtout les plus vulnérables.',
    },
  },
];
